export default __webpack_public_path__ + "static/media/jeremy.1a79ff10.jpeg";